import { render, staticRenderFns } from "./VdtnetTable.vue?vue&type=template&id=31fe5302"
import script from "./VdtnetTable.vue?vue&type=script&lang=js"
export * from "./VdtnetTable.vue?vue&type=script&lang=js"
import style0 from "./VdtnetTable.vue?vue&type=style&index=0&id=31fe5302&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports